<template>
  <div class="wg-row">
    <!-- Modale per la cancellazione release -->
    <wg-modal simple v-if="selectedReleaseToDelete !== null" @closeModal="selectedReleaseToDelete = null;">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Delete release ', 'Cancellare release ') + (quotations.length - selectedReleaseToDelete) + '?' }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              class="small com-anm22-button-red" 
              :value="$anm22.strLang(lang, 'OK', 'OK')" 
              @click="deleteRelease">
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input 
              type="button" 
              class="small" 
              :value="$anm22.strLang(lang, 'Cancel', 'Annulla')" 
              @click="selectedReleaseToDelete = null;">
        </div>
      </div>
    </wg-modal>
    <!-- Modale per la cancellazione file -->
    <wg-modal simple v-if="selectedFileToDelete" @closeModal="selectedFileToDelete = null;">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Delete file?', 'Cancellare file?') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              class="small com-anm22-button-red" 
              :value="$anm22.strLang(lang, 'OK', 'OK')" 
              @click="removeFile">
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input 
              type="button" 
              class="small" 
              :value="$anm22.strLang(lang, 'Cancel', 'Annulla')" 
              @click="selectedFileToDelete = null;">
        </div>
      </div>
    </wg-modal>
    <div class="wg-row">
      <input type="button" :value="$anm22.strLang(lang, 'New release', 'Nuova release')" @click="newRelease" />
    </div>
    <div
        v-for="(release, index) in quotations.slice(0).sort((a,b) => b.date - a.date)"
        :key="'rel-'+index"
        class="wg-row">
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row">
        <div class="com-anm22-app-text-xl">
          {{ 'Release ' + (quotations.length - index) + ' - ' + $moment.unix(release.date).utc().format('YYYY-MM-DD') }}
        </div>
        <img 
            v-if="release.files.length === 0 && !release.notes"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:auto;cursor:pointer;"
            :title="$anm22.strLang(lang, 'Delete release', 'Cancella release')"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            @click.stop="selectedReleaseToDelete = index;">
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <!-- Documenti -->
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding: 0 5px;">
          <div class="wg-row">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, 'Documents', 'Documenti') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <anm22-file-uploader
              v-if="index == 0"
              :uploadUrl="'paglierani/file-upload?projectId='+project.idWorldProject"
              :allowedExtensions="['xls','xlsx','pdf','doc','docx','ps','ai','eps','jpg','jpeg','png','svg','dwg']"
              :onSuccess="addFile"
            ></anm22-file-uploader>
            <div class="wg-row com-anm22-app-scrolling-panel" :style="{height: index === 0 ? '200px' : '158px'}">
              <div
                  v-for="(file,j) in release.files"
                  :key="'file-'+index+'-'+j"
                  class="wg-row file-div"
                  @click="openFile(file)">
                <!-- miniatura se possibile -->
                <img 
                    class="com-anm22-app-img-fixed-height-l"
                    :src="getFileSrc(file.url)">
                <!-- nome file -->
                <div class="com-anm22-app-text-l" style="overflow:hidden;flex-wrap:wrap;word-wrap:break-word;">
                  {{ getFileName(file.url) }}
                </div>
                <!-- delete -->
                <img 
                    class="com-anm22-app-img-fixed-height-m"
                    style="margin-left:auto;cursor:pointer;"
                    :title="$anm22.strLang(lang, 'Delete file', 'Cancella file')"
                    :src="$anm22.icons.getWorldIcon('deleteBlack')"
                    @click.stop="selectedFileToDelete = {release: release, index: j};">
              </div>
            </div>
          </div>
        </div>
        <!-- Note -->
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding: 0 5px;">
          <div class="wg-row">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, 'Notes', 'Note') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <textarea
              :disabled="index > 0"
              style="height:158px;width:100%;max-width:unset;"
              v-model="release.notes"
            ></textarea>
            <template v-if="index == 0">
              <div class="wg-row">
                <input type="button" :value="$anm22.strLang(lang, 'Save notes', 'Salva note')" @click="saveForm" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <paglierani-widget-history
        :projectId="project.idWorldProject"></paglierani-widget-history>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploader.vue";
import PaglieraniWidgetHistory from "./PaglieraniWidgetHistory.vue"

export default {
  components: {
    Anm22FileUploader,
    PaglieraniWidgetHistory
  },
  props: {
    projectId: [Number, String],
    docs: Object
  },
  data() {
    return {
      quotations: [],
      selectedReleaseToDelete: null,
      selectedFileToDelete: null
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }), 
    project() {
      return this.$store.getters['projects/get']([this.projectId]);
    },
  },
  methods: {
    getFileName(url) {
      return url.split('/').reverse()[0];
    },
    getFileSrc(url) {
      if(/\.(jpe?g|png|gif|svg)$/i.test( url )) {
        return this.$anm22.getImagePath(url);
      } else {
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(url)[1];
        if (ext) {
          ext = ext.toLowerCase();
        }
        if ((ext == 'pdf')
            || (ext == 'ai')
            || (ext == 'cad')
            || (ext == 'doc')
            || (ext == 'docx')
            || (ext == 'eps')
            || (ext == 'html')
            || (ext == 'js')
            || (ext == 'ppt')
            || (ext == 'pptx')
            || (ext == 'txt')
            || (ext == 'xls')
            || (ext == 'xlsx')
            || (ext == 'xml')
            || (ext == 'zip')
            ) {
              return 'https://www.anm22.it/app/tasks/utilities/img/file/' + ext + '.svg';
        } else {
            return this.$anm22.icons.getWorldIcon('fileDefault');
        }
      }
    },
    newRelease() {
      this.quotations.push({
        date: this.$moment().unix(),
        files: [],
        notes: ""
      });
      this.saveForm();
    },
    async deleteRelease() {
      const index = this.selectedReleaseToDelete;
      this.selectedReleaseToDelete = null;
      this.quotations.sort((a,b) => b.date - a.date).splice(index, 1);
      this.saveForm();
    },
    saveForm() {
      const docs = {...this.docs};
      docs.quotations = this.quotations;
      this.$emit('save', docs);
    },
    addFile(data) {
      if(data.url) {
        // get last release
        this.quotations.sort((a,b) => b.date - a.date)[0].files.push({
          url: data.url,
          user: this.user.idWorldUser,
          ts: this.$moment().unix()
        });
        this.saveForm();
      }
    },
    async removeFile() {
      const release = this.selectedFileToDelete.release;
      const index = this.selectedFileToDelete.index;
      this.selectedFileToDelete = null;
      const url = release.files[index].url;
      release.files.splice(index, 1);
      this.saveForm();
    },
    openFile(file) {
      window.open(this.$anm22.getImagePath(file.url), '_blank');
    }
  },
  created() {
    this.quotations = this.docs.quotations.slice(0);
  }
}
</script>

<style lang="scss" scoped>
.file-div {
  flex-wrap:nowrap;
  align-items:center;
  margin-top:5px;
  min-height: 36px;
  border-radius: 4px;
  cursor:pointer;
  &:hover {
    background-color: #ccc;
  }
  img {
    margin: 4px;
    border-radius: 4px;
    width: 30px;
  }
}
</style>
